import { isRMCertified } from "./rmCertification";

/** Restricts the sender, independently of the customer's segment or selected material. */
export function isPromotionalMaterialRestricted(
    claims: { kfh_rm?: boolean; kfh_rm_certified?: unknown } | undefined,
    rm: { segment?: string; certified?: boolean } | undefined,
): boolean {
    return claims?.kfh_rm === true && rm?.segment === "Private Banking" && !isRMCertified(claims, rm);
}
